import React, { Component } from "react";
import Axios from "../../../auth/axios";
import { Button, Input, FormGroup, Label, Table, Row, Col } from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-date-picker";
import { fetchVendorInformation } from "../../Services/allServices";

class QualificationInformation extends Component {
  state = {
    ugDegreeData: [],
    ugDegree: "",
    typeOfProgram: "",
    areaOfSpecialisation: "",
    college: "",
    yearOfCompletion: "",
    ugDegreeDocs: [],
    OtherUgDegreeName: "",
    isUgDegreeDocs: [],
    //pg details
    pgTypeOfProgram: "",
    otherPgDegreeName: "",
    pgDegree: "",
    pgAreaOfSpecialisation: "",
    pgCollege: "",
    pgYearOfCompletion: "",
    pgDegreeData: [],
    pgDegreeDocs: [],
    pgDegreeDoc: "",
    //professional course
    professionalCourse: [],
    professionalCourseName: "",
    professionalYearOfCompletion: "",
    professionalCourseAffiliatedBoard: "",
    professionalCourseLicenseNumber: "",
    professionalCourseValidity: "",
    professionalCourseDocs: [],
    professionalCourseDoc: "",
    isProfessionDoc: [],
    dateOfValidity: "",
    //maxDate: moment(new Date()).format("YYYY-MM-DD"),
    isLoading: false,
    postGraduateStatus: false,
    professionalStatus: false,
    isPgDegreeDoc: [],
    isPgProfEdit: false,
    pgProfEditIndex: "",
    editPgDegreeData: [],
    editPgDocData: [],
    editProCourseData: [],
    editProCourseDocData: [],
  };

  disabledFutureDates = () => {
    let disabledDate = [
      {
        year: 2021,
        month: 3,
        day: 15,
      },
    ];
    return disabledDate;
  };

  // handleDayChange = this.handleDayChange.bind(this.yearOfCompletion);

  // edit Professional data
  changeEditProfessionalCourseDeletion = (index) => {
    const { professionalStatus, professionalCourse, professionalCourseDocs } =
      this.state;

    let newprofessionalCourse = professionalCourse.filter((data, i) => {
      if (i == index) {
        return data;
      }
    });

    let newprofessionalCourseDocs = professionalCourseDocs.filter((data, i) => {
      if (i == index) {
        return data;
      }
    });

    //debugger;
    for (var z = 0; z < professionalCourse.length; z++) {
      if (z == index) {
        this.state.dateOfValidity =
          professionalCourse[z].dateOfValidity !== null
            ? new Date(professionalCourse[z].dateOfValidity)
            : "";
        this.state.professionalCourseLicenseNumber =
          professionalCourse[z].professionalCourseLicenseNumber;
        this.state.professionalCourseAffiliatedBoard =
          professionalCourse[z].professionalCourseAffiliatedBoard;
        this.state.professionalYearOfCompletion =
          professionalCourse[z].professionalYearOfCompletion !== ""
            ? new Date(professionalCourse[z].professionalYearOfCompletion)
            : "";
        this.state.professionalCourseName =
          professionalCourse[z].professionalCourseName;
        this.state.professionalCourseValidity =
          professionalCourse[z].professionalCourseValidity;
      }
      // console.log(this.state.professionalYearOfCompletion)
    }
    this.setState({
      professionalStatus: !professionalStatus,
      professionalCourse: newprofessionalCourse,
      professionalCourseDocs: newprofessionalCourseDocs,
      isPgProfEdit: true,
      pgProfEditIndex: index,
    });
  };
  // for edit table of pgDegree
  changeEditHandler = (index) => {
    const { postGraduateStatus, pgDegreeData, pgDegreeDocs, pgDegreeDoc } =
      this.state;

    let newPgDegreeData = pgDegreeData.filter((data, i) => {
      if (i !== index) {
        return data;
      }
    });

    let newPgDegreeDocs = pgDegreeDocs.filter((data, i) => {
      if (i !== index) {
        return data;
      }
    });

    for (var x = 0; x < pgDegreeData.length; x++) {
      // const month = new Date(pgDegreeData[x].completionDate).getUTCMonth() + 1;
      // const day = new Date(pgDegreeData[x].completionDate).getUTCDate();
      // const year = new Date(pgDegreeData[x].completionDate).getUTCFullYear();
      // // const getDate = year + "/" + month + "/" + day;
      // const getpgDate = { day: day, month: month, year: year };
      if (x == index) {
        this.state.pgTypeOfProgram = pgDegreeData[x].programType;
        this.state.pgYearOfCompletion =
          pgDegreeData[x].completionDate !== undefined
            ? new Date(pgDegreeData[x].completionDate)
            : new Date();
        //this.state.pgYearOfCompletion = getpgDate;
        this.state.pgDegree = pgDegreeData[x].degreeName;
        this.state.pgCollege = pgDegreeData[x].instituteName;
        this.state.otherPgDegreeName = pgDegreeData[x].otherPgDegreeName;
        this.state.pgAreaOfSpecialisation = pgDegreeData[x].specialisation;
        // console.log( pgDegreeData[x].completionDate)
      }
    }
    this.setState({
      postGraduateStatus: !postGraduateStatus,
      pgDegreeData: newPgDegreeData,
      pgDegreeDocs: newPgDegreeDocs,
      isPgProfEdit: true,
      pgProfEditIndex: index,
    });
  };

  // for form text fields
  changeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    // console.log(e.target.name, " => ", e.target.value);
  };

  ugDegreeSubmitHandler = async (e) => {
    e.persist();
    const {
      ugDegree,
      typeOfProgram,
      areaOfSpecialisation,
      college,
      yearOfCompletion,
      OtherUgDegreeName,
      ugDegreeDocs,
      pgDegreeData,
      professionalCourse,
      pgDegreeDocs,
      professionalCourseDocs,
    } = this.state;

    if (yearOfCompletion == "") {
      e.preventDefault();
      return toast.error(`Please Select Under Year Of Completion! `, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }

    const ugData = new FormData();

    ugData.append("ugDegree", ugDegree);
    ugData.append("typeOfProgram", typeOfProgram);
    ugData.append("areaOfSpecialisation", areaOfSpecialisation);
    ugData.append("college", college);
    ugData.append("yearOfCompletion", yearOfCompletion);
    // ugData.append('ugDegreeDocs', ugDegreeDocs);
    ugData.append("OtherUgDegreeName", OtherUgDegreeName);
    // console.log('ugDegreeDocs => ', ugDegreeDocs);
    for (let x = 0; x < ugDegreeDocs.length; x++) {
      ugData.append("ugDegreeDocs", ugDegreeDocs[x]);
    }

    if (pgDegreeData.length > 0) {
      ugData.append("pgDegree", JSON.stringify(pgDegreeData));
      // console.log('pgDegreeDocs => ', pgDegreeDocs);
      for (let len = 0; len < pgDegreeDocs.length; len++) {
        ugData.append("pgDegreeDocs" + len, pgDegreeDocs[len][0]);
      }
    }
    // //debugger;
    if (professionalCourse.length > 0) {
      ugData.append("professionalCourse", JSON.stringify(professionalCourse));
      for (let proLen = 0; proLen < professionalCourseDocs.length; proLen++) {
        ugData.append(
          "professionalCourseDocs" + proLen,
          professionalCourseDocs[proLen][0]
        );
      }
    }

    // joi validation for qualification form

    // let { error } = await qualificationDetailsSchema.validate({
    //   areaOfSpecialisation: this.state.areaOfSpecialisation,
    //   typeOfProgram: this.state.typeOfProgram,
    //   college: this.state.college,
    //   ugDegree: this.state.ugDegree,
    // });

    // if (error) alert(error.message);
    // else {
    //   alert("everything alright!");
    // }

    this.setState({ isLoading: true });
    Axios.post("/vendor/vendor-educational", ugData)
      .then((response) => {
        // console.log('Response => => ', response);
        this.setState({ isLoading: false });
        if (!response.data.error) {
          // console.log("yes!");
          // this.setState({ isLoading: false });
          toast.success(`Educational Information Submitted Successfully! `, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          this.props.onChangeQualificationStatusHandler();
          // this.props.changeHandler('2');
        } else {
          // this.setState({ isLoading: false });
          toast.error(
            "Error Occurred! while Submitting Education Information! Please Try Again!",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      })
      .catch(function (error) {
        toast.error(
          `Error Occurred while Submitting Education Information! Please Try Again!`,
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      });
    // console.log('ugDetails Response => ', ugDetails)
    e.preventDefault();
  };

  handleDayChangepg = (ev) => {
    this.setState({
      pgYearOfCompletion: ev.target.value,
    });
  };
  //PGDegree Submit
  pgDegreeSubmitHandler = async (e) => {
    // debugger;
    e.preventDefault();
    const {
      pgTypeOfProgram,
      otherPgDegreeName,
      pgDegree,
      pgAreaOfSpecialisation,
      pgCollege,
      pgYearOfCompletion,
      pgDegreeDocs,
      pgDegreeDoc,
      postGraduateStatus,
    } = this.state;
    if (pgYearOfCompletion == "") {
      e.persist();
      toast.error(`Please Select Post Graduation Year Of Completion! `, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      e.preventDefault();
    }
    if (this.state.pgDegreeData.length >= 3) {
      toast.error(`You can not add More than 3 Post-Graduation Degree! `, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      var pgDegreeData = [...this.state.pgDegreeData];
      pgDegreeData.push({
        programType: pgTypeOfProgram,
        otherPgDegreeName: otherPgDegreeName,
        degreeName: pgDegree,
        specialisation: pgAreaOfSpecialisation,
        instituteName: pgCollege,
        completionDate: moment(pgYearOfCompletion).format("YYYY-MM-DD"),
      });
      // console.log(pgDegreeData);
      pgDegreeDocs.push(pgDegreeDoc);
      // console.log(pgDegreeDocs);
      toast.success("Post Graduation Added Successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      this.setState({
        pgDegreeData,
        pgTypeOfProgram: "",
        otherPgDegreeName: "",
        pgDegree: "",
        pgAreaOfSpecialisation: "",
        pgCollege: "",
        pgYearOfCompletion: "",
        pgDegreeDoc: "",
        pgDegreeDocs,
        postGraduateStatus: !postGraduateStatus,
        editPgDegreeData: pgDegreeData,
        editPgDocData: pgDegreeDocs,
      });
      e.stopPropagation();
    }
  };

  checkFileSizeForDegreeDocs = (event) => {
    let files = event.target.files;
    let size = 400000;
    let err = "";
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + "is too large, please pick a smaller file\n";
      }
    }
    if (err !== "") {
      event.target.value = null;
      // console.log(err);
      //show error toast
      toast.error(`File size exceeds permissible limit`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }

    return true;
  };

  // check MIMEType for other Documents
  checkMimeTypeForDocuments = (event) => {
    let files = event.target.files;
    // console.log(files);
    let count = 0;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (
          files[i].type === "image/png" ||
          files[i].type === "image/jpeg" ||
          files[i].type === "image/jpg" ||
          files[i].type === "image/mpeg" ||
          files[i].type === "application/pdf"
        ) {
          count++;
        } else {
          return false;
        }
      }
    }
    if (count > 0) {
      return true;
    } else {
      return false;
    }
  };

  uploadUgDocHandler = (e) => {
    if (this.checkMimeTypeForDocuments(e)) {
      let isUgDegreeDocs = [];
      for (let i = 0; i < e.target.files.length; i++) {
        isUgDegreeDocs.push(e.target.files[i].name);
      }
      this.setState({ ugDegreeDocs: e.target.files, isUgDegreeDocs });
      // console.log("ugDegree =>", e.target.files);
      toast.success(`UG Document uploaded !`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(
        "Only png/jpg/jpeg/mpeg/pdf format are allowed! Please upload with Correct Format!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  maxSelectedFilesForDegree = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 3) {
      event.target.value = null; // discard selected file
      toast.error(`You can't upload more then 2 files`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return false;
    }
    return true;
  };

  // for PG Docs
  uploadPgDocHandler = (e) => {
    // console.log("pg File loaded");
    // if (this.checkMimeTypeForDocuments(e)) {
    //   this.setState({
    //     pgDegreeDoc: e.target.files,
    //     isPgDegreeDoc: e.target.files[0].name,
    //   });

    if (this.checkMimeTypeForDocuments(e)) {
      let isPgDegreeDoc = [];
      for (let i = 0; i < e.target.files.length; i++) {
        isPgDegreeDoc.push(e.target.files[i].name);
      }
      this.setState({ pgDegreeDoc: e.target.files, isPgDegreeDoc });
      // console.log("ugDegree =>", e.target.files);
      toast.success(`PG Document uploaded !`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    else {
      toast.error(
        "Only png/jpg/jpeg/mpeg/pdf format are allowed! Please upload with Correct Format!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };
  //Professional Date Handler
  changeHandlerProfessional = (ev) => {
    this.setState({
      professionalYearOfCompletion: ev.target.value,
    });
  };
  //debugger;
  changeHandleDateOfValidity = (ev) => {
    this.setState({
      dateOfValidity: ev.target.value,
    });
  };

  // submit professionalCourse
  professionalCourseSubmitHandler = async (ev) => {
    // debugger;
    const {
      professionalCourse,
      professionalCourseName,
      professionalYearOfCompletion,
      professionalCourseAffiliatedBoard,
      professionalCourseLicenseNumber,
      professionalCourseValidity,
      professionalCourseDoc,
      professionalCourseDocs,
      dateOfValidity,
      professionalStatus,
    } = this.state;

    // console.log(
    //   "Length of professionalCourse Array => ",
    //   this.state.professionalCourse.length
    // );\
    //debugger;
    // if (professionalCourseValidity == "limited time") {
    //   if (dateOfValidity == "") {
    //     toast.error(`Please Select Expiry Date!`,
    //       {
    //         position: "top-right",
    //         autoClose: 3000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //       });
    //     return false;
    //   }

    // }
    if (professionalCourse.length >= 5) {
      toast.error(`You can't add more than 5 Professional Courses!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      //debugger;
    } else {
      //   //   let { error } = await professionalcourseSchema.validate({
      //   //     professionalCourseName: this.state.professionalCourseName,
      //   //     professionalCourseAffiliatedBoard: this.state
      //   //       .professionalCourseAffiliated,
      //   //     professionalCourseLicenseNumber: this.state
      //   //       .professionalCourseLicenseNumber,
      //   //     professionalCourseValidity: this.professionalCourseValidity,
      //   //   });

      //   // if (error) alert(error.message);

      //   // else {
      const professionalCourse = [...this.state.professionalCourse];
      professionalCourse.push({
        professionalCourseName,
        professionalYearOfCompletion: moment(
          professionalYearOfCompletion
        ).format("YYYY-MM-DD"),
        professionalCourseAffiliatedBoard,
        professionalCourseLicenseNumber,
        professionalCourseValidity,
        dateOfValidity:
          dateOfValidity == ""
            ? ""
            : moment(dateOfValidity).format("YYYY-MM-DD"),
      });
      // console.log(professionalCourse);

      professionalCourseDocs.push(professionalCourseDoc);
      this.setState({
        professionalCourse,
        professionalCourseName: "",
        professionalYearOfCompletion: "",
        professionalCourseAffiliatedBoard: "",
        professionalCourseLicenseNumber: "",
        professionalCourseValidity: "",
        dateOfValidity: "",
        professionalCourseDocs,
        professionalStatus: !professionalStatus,
        editProCourseData: professionalCourse,
        editProCourseDocData: professionalCourseDocs,
      });

      // }
      ev.preventDefault();
      ev.stopPropagation();
    }
  };

  // delete pgDegree
  handlePgDegreeDelete = (givenIndex) => {
    // console.log("Remove Degree from => ", givenIndex);
    let pgDegreeData = [...this.state.pgDegreeData];
    pgDegreeData = pgDegreeData.filter(
      (element, index) => index !== givenIndex
    );
    // console.log("New pgDegreeData => ", pgDegreeData);
    this.setState({ pgDegreeData });

    this.state.pgDegreeDocs.splice(givenIndex, 1);
    // console.log('pgDegreeDocs => ', this.state.pgDegreeDocs)
  };

  // delete professionalCourse
  handleProfessionalCourseDeletion = (indexNumber) => {
    // console.log("Remove PGCourse from => ", indexNumber);
    let professionalCourse = [...this.state.professionalCourse];
    professionalCourse = professionalCourse.filter(
      (element, index) => index !== indexNumber
    );
    // console.log("New ProfessionalCourseArray => ", professionalCourse);
    this.setState({ professionalCourse });
    this.state.professionalCourseDocs.splice(indexNumber, 1);
  };

  // submit ProfessionalCourse Documents
  uploadProfesionalCourseDocHandler = (ev) => {
    // console.log("pg File loaded");
    if (this.checkMimeTypeForDocuments(ev)) {
      this.setState({
        professionalCourseDoc: ev.target.files,
        isProfessionDoc: ev.target.files[0].name,
      });
    } else {
      toast.error(
        "Only png/jpg/jpeg/mpeg/pdf formats are allowed! Please upload with Correct Format!",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  // change professional course status
  changeProfessionalStatus = () => {
    const {
      professionalStatus,
      isPgProfEdit,
      professionalCourse,
      professionalCourseDocs,
      editProCourseData,
      editProCourseDocData,
    } = this.state;
    if (isPgProfEdit == true) {
      this.state.professionalCourse = editProCourseData;
      this.state.professionalCourseDocs = editProCourseDocData;
    }
    this.setState({
      professionalStatus: !professionalStatus,
    });
  };

  // change postGraduate status
  changePostGraduateStatus = () => {
    // debugger;
    const {
      postGraduateStatus,
      isPgProfEdit,
      pgDegreeData,
      pgDegreeDocs,
      editPgDegreeData,
      editPgDocData,
    } = this.state;
    if (isPgProfEdit == true) {
      this.state.pgDegreeData = editPgDegreeData;
      this.state.pgDegreeDocs = editPgDocData;
    }
    this.setState({
      postGraduateStatus: !postGraduateStatus,
      // pgDegreeData,
      // pgDegreeDocs
    });
  };

  // change handle for graduation date
  handleDayChange = (ev) => {
    this.setState({
      yearOfCompletion: ev.target.value,
    });
  };

  // change handler for pgDegree Date
  handlePgDayChange = (pgDate) => {
    this.setState({
      pgYearOfCompletion: pgDate.target.value,
    });
  };

  // change handler for professional date
  handleProfessionalDayChange = (profDate) => {
    this.setState({
      professionalYearOfCompletion: profDate.target.value,
    });
  };

  componentDidMount = async () => {
    // this.setState({ isLoading: true });
    const vendorInformation = await fetchVendorInformation();
    // this.setState({ isLoading: false });

    // const month = new Date(vendorInformation.data.educationalDetails.ugDegree.completionDate).getUTCMonth() + 1;
    // const day = new Date(vendorInformation.data.educationalDetails.ugDegree.completionDate).getUTCDate();
    // const year = new Date(vendorInformation.data.educationalDetails.ugDegree.completionDate).getUTCFullYear();
    // // const getDate = year + "/" + month + "/" + day;
    // const getDate = { day: day, month: month, year: year };
    // console.log('qualificationInformation Data => =>', getDate);
    this.setState({
      ugDegree: vendorInformation.data.educationalDetails.ugDegree.degreeName,
      OtherUgDegreeName:
        vendorInformation.data.educationalDetails.ugDegree.otherDegreeName,
      typeOfProgram:
        vendorInformation.data.educationalDetails.ugDegree.programType,
      areaOfSpecialisation:
        vendorInformation.data.educationalDetails.ugDegree.specialisation &&
          vendorInformation.data.educationalDetails.ugDegree.specialisation !==
          undefined
          ? vendorInformation.data.educationalDetails.ugDegree.specialisation
          : "",
      college: vendorInformation.data.educationalDetails.ugDegree.instituteName,

      yearOfCompletion:
        vendorInformation.data.educationalDetails.ugDegree.completionDate !==
          undefined
          ? moment(vendorInformation.data.educationalDetails.ugDegree.completionDate).format('YYYY-MM-DD')
          : "",

      isUgDegreeDocs:
        vendorInformation.data.educationalDetails.ugDegree.ugDegreeCertificate,
      pgDegreeData:
        vendorInformation.data.educationalDetails.pgDegree !== null
          ? vendorInformation.data.educationalDetails.pgDegree
          : [],
      editPgDegreeData:
        vendorInformation.data.educationalDetails.pgDegree !== null
          ? vendorInformation.data.educationalDetails.pgDegree
          : [],
      professionalCourse:
        vendorInformation.data.educationalDetails.professionalCourse !== null
          ? vendorInformation.data.educationalDetails.professionalCourse
          : [],
      editProCourseData:
        vendorInformation.data.educationalDetails.professionalCourse !== null
          ? vendorInformation.data.educationalDetails.professionalCourse
          : [],
    });
  };

  render() {
    const {
      ugDegree,
      typeOfProgram,
      areaOfSpecialisation,
      college,
      yearOfCompletion,
      OtherUgDegreeName,
      otherPgDegreeName,
      ugDegreeDocs,
      isUgDegreeDocs,
      pgDegree,
      pgTypeOfProgram,
      pgCollege,
      pgYearOfCompletion,
      pgAreaOfSpecialisation,
      professionalCourseName,
      professionalYearOfCompletion,
      professionalCourseAffiliatedBoard,
      professionalCourseLicenseNumber,
      professionalCourseValidity,
      dateOfValidity,
      maxDate,
      isLoading,
      postGraduateStatus,
      professionalStatus,
      professionalCourse,
      pgDegreeData,
      isPgDegreeDoc,
      professionalCourseDoc,
      isProfessionDoc,
    } = this.state;
    return (
      <form
        className="qualificationForm"
        onSubmit={(e) => this.ugDegreeSubmitHandler(e)}
      >
        <div className="mt-2" style={{ marginLeft: "5px" }} onClick={() => this.props.changeHandler("0")}>
          <span style={{ color: "#174C8B", fontSize: "13px" }}>
            <i className="bi bi-arrow-left-short" />
          </span>
          <span
            className="ml-1"
            style={{
              color: "#174C8B",
              fontSize: "13px",
              cursor: "pointer",
            }}
          >
            Back
          </span>
        </div>
        <div style={{ margin: "5% 9% 5% 9%" }}>
          <span
            style={{
              fontSize: "15px",
              color: "#174C8B",
              fontWeight: "600",
            }}
          >
            UG Degree*
          </span>

          <div className="mt-2">
            <select
              class="form-select selctQualification"
              id="ugDegree"
              onChange={(e) => this.changeHandler(e)}
              name="ugDegree"
              aria-label="Default select example"
              value={ugDegree}
              required
            >
              <option value="" selected>
                Select UG degree
              </option>
              <option value="BSc (General)">BSc (General)</option>
              <option value="BSc (Honors)">BSc (Honors)</option>
              <option value="B.Pharma">B.Pharma</option>
              <option value="BPT">BPT</option>
              <option value="BOT">BOT</option>
              <option value="BSc Nursing">BSc Nursing</option>
              <option value="BNYS">BNYS</option>
              <option value="MBBS">MBBS</option>
              <option value="BUMS">BUMS</option>
              <option value="BAMS">BAMS</option>
              <option value="BHMS">BHMS</option>
              <option value="BTech">BTech</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {ugDegree === "Other" && (
            <div className="mt-2">
              <div className="">
                <input
                  type="text"
                  className="form-control selctQualification"
                  id="OtherUgDegreeName"
                  placeholder="Enter Other UG Degree"
                  name="OtherUgDegreeName"
                  value={OtherUgDegreeName}
                  onChange={(e) => this.changeHandler(e)}
                  required
                />
              </div>
            </div>
          )}

          <div className="mt-2">
            <div className="">
              <input
                type="text"
                className="form-control selctQualification"
                id="CollegeUniversity"
                name="college"
                placeholder="Enter College/University Name"
                value={college}
                onChange={(e) => this.changeHandler(e)}
                required
              />
            </div>
          </div>
          <div className="mt-2">
            <select
              className="form-select selctQualification"
              id="programType"
              name="typeOfProgram"
              onChange={(e) => this.changeHandler(e)}
              value={typeOfProgram}
              required
            >
              <option value="" selected>
                Select Type of Program
              </option>
              <option value="Part Time">Part Time</option>
              <option value="Full Time Regular">Full Time Regular</option>
              <option value="Distance Learning">Distance Learning</option>
            </select>
          </div>

          <div className="mt-2">
            <div className="">
              <input
                type="text"
                className="form-control selctQualification"
                id="Specialisation"
                name="areaOfSpecialisation"
                placeholder="Enter area of specialisation"
                value={areaOfSpecialisation}
                onChange={(e) => this.changeHandler(e)}
                required
              />
            </div>
          </div>

          <div className="mt-2">
            <Input
              className="form-control selctQualification"
              type="text"
              placeholder="choose completion date"
              name="yearOfCompletion"
              value={yearOfCompletion}
              onChange={(e) => this.handleDayChange(e)}
              onFocus={(e) => (e.target.type = "date")}
              onBlur={(e) => (e.target.type = "text")}
            // required
            />
            {/* <DatePicker
              format="dd-MM-y"
              className="none-border"
              maxDate={new Date()}
              id="yearOfCompletion"
              onChange={this.handleDayChange}
              value={yearOfCompletion}
              name="yearOfCompletion"
              placeHolder="dd-mm-yyyy"
              required
              style={{}}
            /> */}
          </div>

          <div className="hide-if-value mt-2">
            <label class="qualification-label">
              <input
                type="file"
                id="ugDegreeDocs"
                multiple
                name="ugDegreeDocs"
                onChange={(e) => this.uploadUgDocHandler(e)}
                required={isUgDegreeDocs.length > 0 ? false : true}
              />
              <small class="name1">
                <i className="bi bi-download downloadIcon"></i>Choose file
              </small>
            </label>
            {isUgDegreeDocs.length > 0 ? (
              isUgDegreeDocs.map((data) => (
                <span className="file_message">
                  {" "}
                  {data.split("/")[data.split("/").length - 1]}
                </span>
              ))
            ) : (
              <span className="file_message">Upload UG degree</span>
            )}
          </div>
        </div>

        {/* Postgraduate Education Details */}
        <div className="postGraContainer">
          <h4 className="postGraHeading">
            <span className="pl-4 pt-3 pb-2 d-block">
              Postgraduate Education Details
            </span>
          </h4>

          {pgDegreeData.length > 0 && (
            <table class="table rounded">
              <thead
                style={{
                  backgroundColor: "#083E95",
                  color: "white",
                  fontSize: "8px",
                }}
              >
                <tr>
                  <th scope="col">PG Degree</th>
                  <th scope="col">Type of Program</th>
                  <th scope="col">Year of Completion</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody
                style={{
                  backgroundColor: "#E3E5EB",
                  fontSize: "9px",
                  fontWeight: "600",
                }}
              >
                {pgDegreeData.map((data, index) => (
                  <tr>
                    <th scope="row">
                      {data.degreeName !== "Other"
                        ? data.degreeName
                        : data.otherPgDegreeName}
                    </th>
                    <td>{data.programType}</td>
                    <td>{moment(data.completionDate).format("DD-MM-YYYY")}</td>
                    <td>
                      <div
                        style={{ display: "flex" }}
                        onClick={() => this.handlePgDegreeDelete(index)}
                      >
                        <i
                          className="bi bi-trash3-fill"
                          style={{
                            color: "red",
                            fontSize: "12px",
                            cursor: "pointer",
                          }}
                          aria-hidden="true"
                        ></i>
                        <i
                          className="bi bi-pencil-square ml-2"
                          style={{
                            color: "#00adee",
                            fontSize: "12px",
                            cursor: "pointer",
                          }}
                          aria-hidden="true"
                          onClick={() => this.changeEditHandler(index)}
                        ></i>
                      </div>
                      {/* <Button
                        color="link"
                        size="sm"
                        onClick={() => this.handlePgDegreeDelete(index)}
                      >
                        <i
                          className="fa fa-trash"
                          style={{
                            color: "red",
                            fontSize: "20px",
                          }}
                          aria-hidden="true"
                        ></i>
                        <i
                          className="fa fa-edit ml-2"
                          style={{
                            color: "#00adee",
                            fontSize: "20px",
                          }}
                          aria-hidden="true"
                          onClick={() => this.changeEditHandler(index)}
                        ></i>
                      </Button> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {postGraduateStatus === true && (
            <div className="px-4">
              <form onSubmit={(e) => this.pgDegreeSubmitHandler(e)}>
                <div className="row">
                  <div className="col-lg-12  mt-2 mb-2">
                    <select
                      className="form-select selctQualification1"
                      id="pgDegree"
                      name="pgDegree"
                      onChange={(e) => this.changeHandler(e)}
                      value={pgDegree}
                      required
                    >
                      <option value="" selected>
                        Select Degree
                      </option>
                      <option value="MSc">MSc</option>
                      <option value="MPhil">MPhil</option>
                      <option value="Doctorate">Doctorate</option>
                      <option value="MA">MA</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  {pgDegree === "Other" && (
                    <div className="col-lg-12  mb-2">
                      <input
                        type="text"
                        className="form-control selctQualification1"
                        id="otherPgDegreeName"
                        placeholder="Enter Other PG Degree"
                        name="otherPgDegreeName"
                        onChange={(e) => this.changeHandler(e)}
                        value={otherPgDegreeName}
                        required
                      />
                    </div>
                  )}
                </div>

                <div className="row">
                  <div className="col-lg-12 mb-2">
                    <select
                      className="form-select selctQualification1"
                      id="pgTypeOfProgram"
                      name="pgTypeOfProgram"
                      onChange={(e) => this.changeHandler(e)}
                      value={pgTypeOfProgram}
                      required
                    >
                      <option value="" selected>
                        Select type of program
                      </option>
                      <option value="Part Time">Part Time</option>
                      <option value="Full Time Regular">
                        Full Time Regular
                      </option>
                      <option value="Distance Learning">
                        Distance Learning
                      </option>
                    </select>
                  </div>

                  <div className="col-lg-12 mb-2">
                    <input
                      type="text"
                      className="form-control selctQualification1"
                      id="pgAreaOfSpecialisation"
                      name="pgAreaOfSpecialisation"
                      value={pgAreaOfSpecialisation}
                      onChange={(e) => this.changeHandler(e)}
                      placeholder="Enter area of specialisation"
                      required
                    />
                  </div>

                  <div className="col-lg-12 mb-2">
                    <input
                      type="text"
                      className="form-control selctQualification1"
                      id="pgCollege"
                      name="pgCollege"
                      onChange={(e) => this.changeHandler(e)}
                      value={pgCollege}
                      placeholder="Enter College/University Name"
                      required
                    />
                  </div>
                </div>

                {/* <div
                  className="col-lg-12 col mb-2"
                  style={{
                    height: "40px",
                    background: "white",
                    borderRadius: "4px",
                    padding: "9px",
                  }}
                > */}
                <Input
                  className="mb-2"
                  type="text"
                  placeholder="choose completion date"
                  value={pgYearOfCompletion}
                  name="pgYearOfCompletion"
                  onChange={(e) => this.handleDayChangepg(e)}
                  style={{ border: 0, fontSize: "14px" }}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => (e.target.type = "text")}
                  required
                />
                {/* <DatePicker
                    format="dd-MM-y"
                    className="none-border"
                    maxDate={new Date()}
                    id="yearOfCompletion"
                    onChange={this.handleDayChangepg}
                    value={pgYearOfCompletion}
                    name="pgYearOfCompletion"
                    placeHolder="dd-mm-yyyy"
                    required
                    style={{}}
                  /> */}
                {/* </div> */}
                <div
                  className="col-lg-12 col mb-2"
                  style={{
                    padding: "0px",
                  }}
                >
                  <label class="qualification-label">
                    <input
                      type="file"
                      id="pgDegreeDocs"
                      multiple
                      name="pgDegreeDocs"
                      onChange={(e) => this.uploadPgDocHandler(e)}
                    />
                    <small class="name1">
                      <i className="bi bi-download downloadIcon"></i>Choose file
                    </small>
                  </label>

                  {isPgDegreeDoc.length > 0 ? (
                    isPgDegreeDoc.map((data) => (
                      <span className="file_message">
                        {" "}
                        {data.split("/")[data.split("/").length - 1]}
                      </span>
                    ))
                  ) : (
                    <span className="file_message">Upload PG degree</span>
                  )}
                </div>

                <div className="col-md-12 col-lg-12 text-center pb-3">
                  <button
                    type="submit"
                    className="btn btn-warning mt-2 "
                    style={{
                      padding: "5px 26px",
                      // margin: "0px 6px",
                      color: "white",
                    }}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={(e) => this.changePostGraduateStatus(e)}
                    className="btn btn-outline-warning mt-2 close_button"
                    style={{
                      padding: "5px 26px",
                      margin: "0px 4px",
                    }}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          )}

          {postGraduateStatus === false && (
            <div className="postMainCon pl-4 pb-4">
              <div
                className="postGraAdd"
                onClick={(e) => this.changePostGraduateStatus(e)}
              >
                <span>+</span>
              </div>
              <div className="postPGDegrreMain">
                <span className="mainText1">
                  {pgDegreeData.length > 0
                    ? "Add More PG Degree"
                    : "Add PG Degree"}
                </span>
                <span className="mainText2">(Or Skip This)</span>
              </div>
            </div>
          )}
        </div>
        {/* Postgraduate Education Details End */}

        {/* Professional Course start */}
        <div className="postGraContainer mb-5">
          <h4 className="postGraHeading pl-4 pt-3 pb-2">Professional Course</h4>

          {professionalCourse.length > 0 && (
            <table class="table">
              <thead
                style={{
                  backgroundColor: "#083E95",
                  color: "white",
                  fontSize: "8px",
                }}
              >
                <tr>
                  <th scope="col">Coursee</th>
                  <th scope="col">Year of Completion</th>
                  <th scope="col">Certificatie/License Number</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody
                style={{
                  backgroundColor: "#E3E5EB",
                  fontSize: "9px",
                  fontWeight: "600",
                }}
              >
                {professionalCourse.map((data, index) => (
                  <tr>
                    <th scope="row">{data.professionalCourseName}</th>
                    <td>
                      {moment(data.professionalYearOfCompletion).format(
                        "DD-MM-YYYY"
                      )}
                    </td>
                    <td>{data.professionalCourseLicenseNumber}</td>
                    <td>
                      <div
                        style={{ display: "flex" }}
                        onClick={() =>
                          this.handleProfessionalCourseDeletion(index)
                        }
                      >
                        <i
                          className="bi bi-trash3-fill"
                          style={{
                            color: "red",
                            fontSize: "12px",
                          }}
                          aria-hidden="true"
                        ></i>
                        <i
                          className="bi bi-pencil-square ml-2"
                          style={{
                            color: "#00adee",
                            fontSize: "12px",
                          }}
                          aria-hidden="true"
                          onClick={() =>
                            this.changeEditProfessionalCourseDeletion(index)
                          }
                        ></i>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {professionalStatus === true && (
            <div className="px-4">
              <form onSubmit={(e) => this.professionalCourseSubmitHandler(e)}>
                <div className="row">
                  <div className="col-lg-12 col mt-2 mb-2">
                    <input
                      type="text"
                      className="form-control selctQualification1"
                      id="professionalCourseName"
                      name="professionalCourseName"
                      placeholder="Enter Course /Program Name"
                      value={professionalCourseName}
                      onChange={(e) => this.changeHandler(e)}
                      required
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12 mb-2">
                    {/* <div
                      style={{
                        background: "white",
                        borderRadius: "4px",
                        padding: "5px 9px",
                        fontFamily: "Montserrat",
                        fontSize: "11px",
                      }}
                    > */}

                    <Input
                      className="mb-2"
                      type="text"
                      placeholder="choose completion date"
                      name="professionalYearOfCompletion"
                      value={professionalYearOfCompletion}
                      onChange={(e) => this.changeHandlerProfessional(e)}
                      style={{ border: 0, fontSize: "14px" }}
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => (e.target.type = "text")}
                    // required
                    />
                    {/* <DatePicker
                        format="dd-MM-y"
                        className="none-border"
                        value={professionalYearOfCompletion}
                        name="professionalYearOfCompletion"
                        onChange={this.changeHandlerProfessional}
                        placeholder="dd-mm-yyyy"
                        maxDate={new Date()}
                        required
                      /> */}
                    {/* </div> */}
                    {/* <div className="form-group datepickerBorder">
                      <DatePicker
                        format="dd-MM-y"
                        className="none-border"
                        value={professionalYearOfCompletion}
                        name="professionalYearOfCompletion"
                        onChange={this.changeHandlerProfessional}
                        placeholder="dd-mm-yyyy"
                        maxDate={new Date()}
                        required
                      />
                    </div> */}
                  </div>

                  <div className="col-lg-12 mb-2">
                    <input
                      type="text"
                      className="form-control selctQualification1"
                      id="professionalCourseAffiliatedBoard"
                      name="professionalCourseAffiliatedBoard"
                      placeholder="Affiliated Center/ Board/ Society/ Hospital Name"
                      value={professionalCourseAffiliatedBoard}
                      onChange={(e) => this.changeHandler(e)}
                      required
                    />
                  </div>

                  <div className="col-lg-12 mb-2">
                    <input
                      type="text"
                      className="form-control selctQualification1"
                      id="professionalCourseLicenseNumber"
                      name="professionalCourseLicenseNumber"
                      placeholder="Certificate/ License Number"
                      value={professionalCourseLicenseNumber}
                      onChange={(e) => this.changeHandler(e)}
                      required
                    />
                  </div>
                  <div className="col-lg-12 mb-2">
                    <select
                      className="form-select selctQualification1"
                      id="professionalCourseValidity"
                      name="professionalCourseValidity"
                      onChange={(e) => this.changeHandler(e)}
                      value={professionalCourseValidity}
                      required
                    >
                      <option value="" disabled>
                        Select Validity of Course Certificate
                      </option>
                      <option value="limited time">Limited Time</option>
                      <option value="life time">Life Time</option>
                      <option value="na">NA</option>
                    </select>
                    {/* <select
                      className="form-select selctQualification1"
                      id="pgDegree"
                      name="pgDegree"
                      onChange={(e)=>this.changeHandler(e)}
                      value={pgDegree}
                      required
                    >
                      <option value="">PG Degree</option>
                      <option value="MSc">MSc</option>
                      <option value="MPhil">MPhil</option>
                      <option value="Doctorate">Doctorate</option>
                      <option value="MA">MA</option>
                      <option value="Other">Other</option>
                    </select> */}
                  </div>
                  {/* dateOfValidity */}
                  {/* {this.state.professionalCourseValidity === "limited time" ? (
                    <div className="col-lg-12 col">
                      <div className="form-group datepickerBorder">
                        <label htmlFor="dateOfValidity" className="d-block">
                          Date of Expiry
                        </label>
                        <DatePicker
                          format="dd-MM-y"
                          className="none-border"
                          // type="date"
                          //className="form-control"
                          //id="dateOfValidity"
                          name="dateOfValidity"
                          value={dateOfValidity}
                          placeholder="dd-mm-yyyy"
                          minDate={new Date()}
                          onChange={this.changeHandleDateOfValidity}
                          required
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}
                </div>

                {professionalCourseValidity === "limited time" && (
                  <div
                    className="col-lg-12  mb-2 selctQualification1"
                    style={{
                      background: "white",
                      border: "1px solid #e3d9d9",
                      borderRadius: "4px",
                      padding: "0px 9px",
                    }}
                  >
                    <Input
                      className="mb-2"
                      type="text"
                      placeholder="Choose expiry date"
                      name="dateOfValidity"
                      value={dateOfValidity}
                      onChange={(e) => this.changeHandleDateOfValidity(e)}
                      style={{ border: 0, fontSize: "14px" }}
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => (e.target.type = "text")}
                      min={moment().format("YYYY-MM-DD")}
                      required
                    />

                    {/* <DatePicker
                      format="dd-MM-y"
                      className="none-border"
                      // type="date"
                      //className="form-control"
                      //id="dateOfValidity"
                      name="dateOfValidity"
                      value={dateOfValidity}
                      placeholder="dd-mm-yyyy"
                      minDate={new Date()}
                      onChange={this.changeHandleDateOfValidity}
                      required
                    /> */}
                  </div>
                )}

                <div
                  className="col-lg-12 mb-2"
                  style={{
                    padding: "0px",
                  }}
                >
                  <label class="qualification-label">
                    <input
                      type="file"
                      id="professionalCourseDocs"
                      multiple
                      name="professionalCourseDocs"
                      onChange={(e) =>
                        this.uploadProfesionalCourseDocHandler(e)
                      }
                      required
                    />
                    <small class="name1">
                      <i className="bi bi-download downloadIcon"></i>Choose file
                    </small>
                  </label>
                  {isProfessionDoc.length > 0 ? (
                    <span className="file_message">
                      {
                        isProfessionDoc.split("/")[
                        isProfessionDoc.split("/").length - 1
                        ]
                      }
                    </span>
                  ) : (
                    <span className="file_message">Upload Certificate</span>
                  )}
                  {/* <input
                    class="form-control form-control-md"
                    id="formFileSm"
                    type="file"
                  /> */}
                </div>

                <div className="col-md-12 col-lg-12 text-center pb-3">
                  <button
                    type="submit"
                    className="btn btn-warning mt-2 "
                    style={{
                      padding: "5px 26px",
                      // margin: "0px 6px",
                      color: "white",
                    }}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={(e) => this.changeProfessionalStatus(e)}
                    className="btn btn-outline-warning mt-2 close_button"
                    style={{
                      padding: "5px 26px",
                      margin: "0px 4px",
                    }}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          )}

          {professionalStatus === false && (
            <div className="postMainCon pl-4 pb-4">
              <div
                className="postGraAdd"
                onClick={(e) => this.changeProfessionalStatus(e)}
              >
                <span>+</span>
              </div>
              <div className="postPGDegrreMain">
                <div className="mainText1">
                  {pgDegreeData.length > 0
                    ? "Add More Professional Course"
                    : "Add Professional Course"}
                </div>
                <div className="mainText2">(Or Skip This)</div>
              </div>
            </div>
          )}
        </div>
        {/* Professional Course end*/}

        {isLoading === true ? (
          <Row>
            <Col className="d-flex justify-content-center p-2 mb-3">
              <Button
                type="submit"
                color="warning"
                style={{ color: "#fff" }}
                className="px-5"
              >
                <span class="spinner-border spinner-border-sm" />
                Save & Next
              </Button>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col className="d-flex justify-content-center p-2 mb-3">
              <Button
                type="submit"
                color="warning"
                style={{ color: "#fff" }}
                className="px-5"
              >
                Save & Next
              </Button>
            </Col>
          </Row>
        )}
      </form>
    );
  }
}

export default QualificationInformation;
